import bnc from "bnc";

const name = "smt-register-form";
export const block = new bnc(name);
export const i18nProject = name;
